import React from "react";
import { connect } from "react-redux";
import { Card, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import Search from "../../../assets/images/search.svg";
import { getreportcustomer, getReportOaList, oaDetailsCsv, previewPo, shortStr, verifyDateFormat } from "../../../actions";
import "../../../assets/css/button.css";
import "../../../assets/css/popup.css";
import Re from "../../../assets/images/green2.svg";
import Navbar from "../../../layouts/Navbar";
import Sidebar from "../../../layouts/Sidebar";
import Spinner from "../../../Components/loader";
import LoadingOverlay from "../../../Components/LoadingOverlay";
import Pagination from "../../../Components/Pagination";
import parse from 'html-react-parser';
import { Link } from "react-router-dom";
import OaFilter from "./oaFilter";
import OaView from "./oaView";
import OaConfirm from "./oaConfirm";
import Art from "../../../assets/images/art.svg";


const role = localStorage.getItem('userRole');
class OrderAcceptence extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            all_report_customer: [],
            allData: [],
            show: false,
            modal: false,
            data: [],
            previewQutationTxt: "",
            target: null,
            pageNo: 0,
            filterData: {
                searchKey: null,
                pageNo: 0,
                fromDate: null,
                toDate: null,
                sizeOfPage: 20,
                size: 10
            },
            oaPopup: false
        };
        this.onChange = this.onChange.bind(this);
        this.getCustomerExe = this.getCustomerExe.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.resetHandler = this.resetHandler.bind(this);
        this.searchHandler = this.searchHandler.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.oaShow = this.oaShow.bind(this);
        this.oaClose = this.oaClose.bind(this);
        this.onCountData = this.onCountData.bind(this);
        this.debouncedSearchHandler = this.debounce(this.searchHandler, 400);
    }

    debounce(func, delay) {
        let timer;
        return (...args) => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }

    componentDidMount() {
        this.props.dispatch(getReportOaList(this.state.filterData));
    }

    handleClick = (event) => {
        if (!this.state.show) {
            this.setState({
                show: true,
                target: event.target
            })
        } else {
            this.setState({
                show: false,
            })
        }
    };
    handleSubmit(filterData) {
        let data = { ...this.state.filterData };
        data.fromDate = filterData.fromDate;
        data.toDate = filterData.toDate;
        this.setState({
            filterData: data
        })
        this.props.dispatch(getReportOaList(data));
        this.setState({
            show: false,
        })
    }

    downloadCsv = () => {
        console.log("downloadCsv");
        const { filterData } = this.state;
        const { pageNo, sizeOfPage, size, ...csvFilterData } = filterData;
        this.props.dispatch(oaDetailsCsv(csvFilterData));
    }

    handleShow(row) {
        this.setState({
            modal: true,
            data: row
        })
        this.props.dispatch(previewPo(row.purchaseOrderId));
    }
    handleClose() {
        this.setState({
            modal: false,
            previewQutationTxt: undefined
        })
    }
    resetHandler() {
        let data = { ...this.state.filterData };
        data.fromDate = null;
        data.toDate = null;
        this.setState({
            filterData: data
        })
        this.props.dispatch(getReportOaList(data));
        this.setState({
            show: false,
        })
    }
    getCustomerExe() {
        this.setState({
            show: false,
            filterData: []
        })
        this.props.dispatch(getreportcustomer(0));
    }
    componentDidUpdate(prevProps) {
        if (prevProps.allData !== this.props.allData) {
            this.setState({ allData: this.props.allData });
        }
    }
    searchHandler(e) {
        const { filterData } = this.state;
        let data = { ...filterData };
        data.searchKey = e.target.value;
        data.pageNo = 0;
        this.setState({
            filterData: data
        })
        this.props.dispatch(getReportOaList(data));
    }
    onChange(pageNo) {
        let data = { ...this.state.filterData };
        data.pageNo = pageNo;
        this.setState({
            filterData: data
        })
        this.props.dispatch(getReportOaList(data));
    }

    oaShow(val) {
        this.setState({
            oaPopup: true,
            data: val
        })
    }

    oaClose() {
        this.setState({ oaPopup: false });
    }

    onCountData(e) {
        let data = { ...this.state.filterData };
        data.size = e.target.value;
        this.setState({
            filterData: data
        })
        this.props.dispatch(getReportOaList(data));
    }

    getPoNumberColorMap() {
        const colorMap = new Map();
        const content = this.state.allData?.content || [];
        const uniquePoNumbers = [...new Set(content.map(item => item?.poNumber).filter(Boolean))];
        const colors = ['#ffcd031a', '#ffffff'];

        uniquePoNumbers.forEach((poNumber, index) => {
            colorMap.set(poNumber, colors[index % 2]);
        });

        return colorMap;
    }

    getRowBackgroundColor(poNumber) {
        if (!poNumber) return '#ffffff';
        const colorMap = this.getPoNumberColorMap();
        return colorMap.get(poNumber) || '#ffffff';
    }

    render() {
        const { allData, show, target, modal, previewQutationTxt, oaPopup } = this.state;

        const oaAll = this.props.oaAll;
        let data = {
            totalElements: oaAll?.totalElements || allData?.totalElements,
            totalPages: oaAll?.totalPages || allData?.totalPages,
            offset: oaAll?.pageable?.offset || allData?.pageable?.offset,
            numberOfElements: oaAll?.numberOfElements || allData?.numberOfElements,
            num: (oaAll?.number || allData?.number || 0) + 1
        }

        return (
            <>
                <div>
                    <Navbar />
                    <div className="dashboard-page">
                        <div className="dashboard-sidebar">
                            <Sidebar />
                        </div>
                        <div className="dashboard-main">
                            <Card className="staff-page">
                                <div className="page-head-split">
                                    <div className="head-colums">
                                        <div className="head-part-tab">
                                            <img src={Re} alt="..." className="head-imgs" />
                                            <h5>OA Details</h5>
                                        </div>
                                        <div className="tab-links">
                                            <Link to={"/" + role + "/oa"} className="active">OA Details</Link>
                                            <Link to={"/" + role + "/oa/oa_report"} >PSO</Link>
                                            <Link to={"/" + role + "/oa/oaConfirmPage"}>MC</Link>
                                            <Link to={"/" + role + "/oa/oaDownload"}>MC Report</Link>
                                            <Link to={"/" + role + "/oa/ms"}>Inward</Link>
                                        </div>
                                        <button className="download_btn" onClick={this.downloadCsv}>
                                            <img src={Art} alt=".." /> CSV
                                        </button>
                                        <div className="customer-search oa-search">
                                            <span><img src={Search} alt=".." className="search-img" /></span>
                                            <Form.Control type="search" placeholder="Search" onChange={this.debouncedSearchHandler} className="main-search" />
                                        </div>
                                        <OaFilter
                                            onSubmit={this.handleSubmit}
                                            getCustomerExe={this.getCustomerExe}
                                            handleClick={this.handleClick}
                                            reset={this.resetHandler}
                                            show={show} target={target}
                                            str={this.props.str}
                                        />

                                    </div>
                                </div>
                                <div className="table-class" style={{ position: 'relative' }}>
                                    <LoadingOverlay 
                                        loading={this.props.loading} 
                                        showCondition={allData && allData?.content?.length > 0}
                                        pointerEvents="auto"
                                    />
                                    <table class="table table-borderless uniq-table">
                                        <thead>
                                            <tr>
                                                <th>PO No</th>
                                                <th>PO Date</th>
                                                <th scope="col" >OA No</th>
                                                <th scope="col">OA Date</th>
                                                <th scope="col">Customer</th>
                                                <th>Project</th>
                                                <th>Art No</th>
                                                <th>Product Name</th>
                                                <th className="txt-center">OA Qty</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allData && allData?.content?.length > 0 ? (
                                                allData?.content?.map((one, i) => (
                                                    <tr key={i} style={{ backgroundColor: this.getRowBackgroundColor(one?.poNumber) }}>
                                                        <td onClick={() => this.handleShow(one)} className="under-line">{shortStr(one?.poNumber)}</td>
                                                        <td onClick={() => this.handleShow(one)}>{verifyDateFormat(one?.poGeneratedDate)}</td>
                                                        <td onClick={() => this.oaShow(one)}>
                                                            <OverlayTrigger placement="top-start" overlay={<Tooltip id="tooltip-disabled"> {one?.oaNumber || "-"}</Tooltip>}>
                                                                <span className="d-inline-block value-add">
                                                                    {one?.oaNumber || "-"}
                                                                </span>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td onClick={() => this.oaShow(one)}>{verifyDateFormat(one?.oaDate)}</td>
                                                        <td onClick={() => this.oaShow(one)}>{one?.customerName || "-"}</td>
                                                        <td onClick={() => this.oaShow(one)}>
                                                            <OverlayTrigger placement="top-start" overlay={<Tooltip id="tooltip-disabled"> {one?.projectName || "-"}</Tooltip>}>
                                                                <span className="d-inline-block value-add">
                                                                    {one?.projectName || "-"}
                                                                </span>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td onClick={() => this.handleShow(one)}>{one?.articleId}</td>
                                                        <td onClick={() => this.oaShow(one)} className="product_name">
                                                            <OverlayTrigger placement="bottom-start" overlay={<Tooltip id="tooltip-disabled"> {parse(one?.productName || "-")}</Tooltip>}>
                                                                <span className="d-inline-block">
                                                                    {parse(one?.productName || "-")}
                                                                </span>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td onClick={() => this.oaShow(one)} className="end-child">{one?.productQuantity}</td>
                                                    </tr>
                                                ))
                                            ) : !this.props.loading ?
                                                <h1 className="empty-data">No Records Found</h1> :
                                                <tr><td colSpan="9" style={{ textAlign: 'center', padding: '50px' }}><Spinner /></td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </Card>
                            <Pagination data={data} onChange={this.onChange} hide="hide" />
                            <div className="count-one">
                                <div className="page-page">Select your items size</div>
                            </div>
                            <select className="select-input" onChange={this.onCountData}>
                                <option vlaue="10">10</option>
                                <option vlaue="20">20</option>
                                <option vlaue="50">50</option>
                                <option vlaue="100">100</option>
                            </select>
                        </div>
                    </div>
                    <OaView
                        show={modal}
                        onHide={this.handleClose}
                        data={this.state.data}
                        preview={previewQutationTxt}
                    />
                    <OaConfirm
                        data={this.state.data}
                        show={oaPopup}
                        onHide={this.oaClose} />
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const { oa } = state;
    return {
        loading: state.oa.loading,
        page: state.oa.page,
        allData: { content: oa.newData },
        oaAll: oa.oaAll,
        csvData: state.oa.csvData,
    };
};
export default connect(mapStateToProps)(OrderAcceptence);

